import { render, staticRenderFns } from "./ConfigAlertOpsgenie.vue?vue&type=template&id=75ae2439&"
import script from "./ConfigAlertOpsgenie.vue?vue&type=script&lang=js&"
export * from "./ConfigAlertOpsgenie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports